import { FeatureCollection, GeoJsonProperties, Geometry } from 'geojson';
import { useDeepCompareMemo } from 'use-deep-compare';
import { Block } from '../../../../services/entities/impl/blfApi/schemas/block';
import {
  Point,
  PointColorConfiguration,
  PointFeatureProperties,
} from '../types';
import { useBlockGeoJsonFeatures } from './useBlockGeoJsonFeatures';
import { usePointGeoJsonFeatures } from './usePointGeoJsonFeatures';

export const usePointHeatmap = <P extends Point = Point>(
  points: P[],
  pointColorConfig: PointColorConfiguration<P>,
  blocks: Block[]
): {
  pointsFeatureCollection: FeatureCollection<
    Geometry,
    PointFeatureProperties<P>
  >;
  blocksFeatureCollection: FeatureCollection<Geometry, GeoJsonProperties>;
} => {
  const pointsFeatureCollection = usePointGeoJsonFeatures<P>(
    points,
    pointColorConfig
  );

  const blocksFeatureCollection = useBlockGeoJsonFeatures(blocks);

  return useDeepCompareMemo(
    () => ({
      pointsFeatureCollection,
      blocksFeatureCollection,
    }),
    [pointsFeatureCollection, blocksFeatureCollection]
  );
};
